import { pixelDrawingBoundsSchema } from 'features/libra/drawing/drawingBounds'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function normalizeZoneBoundsStorage(
  zoneValues: readonly unknown[]
): unknown[] {
  return zoneValues.map((zone) => {
    if (!isRecord(zone)) return zone

    let normalized = zone
    for (const field of ['drawing_bounds', 'ai_initial_bounds']) {
      const bounds = normalized[field]
      if (
        isRecord(bounds) &&
        pixelDrawingBoundsSchema.safeParse(bounds).success
      )
        normalized = { ...normalized, [field]: [bounds] }
    }
    return normalized
  })
}
